/* RESPONSIBLE TEAM: team-frontend-tech */
import { computed } from '@ember/object';
import { equal, and } from '@ember/object/computed';
import { typeOf } from '@ember/utils';
import Predicate from 'predicates/models/predicate';
import { applyFunction, ternary, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
export default Predicate.extend({
  genericType: 'date',
  isEditable: true,
  isDateType: true,
  isValid: ternaryToProperty('isKnownOrUnknownComparison', 'isValidForNoValue', 'isValidForValue'),
  goalComparison: ternary('isUserEventPredicate', 'triggered', 'known'),
  typeOfValue: applyFunction(typeOf, 'value'),
  valueIsObject: equal('typeOfValue', 'object'),
  valueIsString: equal('typeOfValue', 'string'),
  isAbsoluteDate: and('valueIsObject', 'isDateType'),
  isRelativeDate: and('valueIsString', 'isDateType'),
  isUserEventDateType: equal('type', 'user_event_date'),
  getDefaultValue(context = {}) {
    if (this.isValueBasedComparison) {
      return '';
    } else {
      return null;
    }
  },
  changeComparison(comparison) {
    this.setProperties({
      comparison: comparison.replace(/:(relative|absolute)/, ''),
      value: this._intializeValueForComparison(comparison)
    });
  },
  initializeDefaultValue() {
    if (this.isKnownOrUnknownComparison) {
      this.set('value', null);
    } else if (this.hasNoValue) {
      this.set('value', '');
    }
  },
  _intializeValueForComparison(comparison) {
    if (comparison === 'known' || comparison === 'unknown') {
      return null;
    } else if (comparison.endsWith('absolute') && (this.valueIsString || this.valueIsNull)) {
      return this._makeCurrentDateForAbsoluteComparison();
    } else if (comparison.endsWith('relative') && (this.valueIsObject || this.valueIsNull)) {
      return '';
    } else {
      return this.value;
    }
  },
  _makeCurrentDateForAbsoluteComparison() {
    let date = new Date();
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    };
  },
  comparisonOptionValue: computed('comparison', 'isAbsoluteDate', 'isRelativeDate', function () {
    let comparison = this.comparison;
    if (this.isRelativeDate) {
      return `${comparison}:relative`;
    } else if (this.isAbsoluteDate) {
      return `${comparison}:absolute`;
    } else {
      return comparison;
    }
  })
});